import "./index.scss";

const BlinkingMessage = ({ text }: { text: string }) => {
  return <p className="g-blinking-message">{text}</p>;
};

export default BlinkingMessage;
